import { Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutLtlStop extends Layout {
    labelPickupAndDelivery: Label;
    tableStops: Table;
}
